import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isFirstVisit: true,
};

const firstVisitSlice = createSlice({
  name: "firstVisit",
  initialState,
  reducers: {
    setFirstVisitFalse: (state) => {
      state.isFirstVisit = false;
    },
  },
});

export const { setFirstVisitFalse } = firstVisitSlice.actions;
export default firstVisitSlice.reducer;
